import React from 'react';
import './ReviewsDisplay.css';

interface ReviewsDisplayProps {
  average: number;
  count: number;
  reviewsLabel?: string;
  onClick?: () => void;
}

const ReviewsDisplay: React.FC<ReviewsDisplayProps> = ({ average, count, reviewsLabel = 'reviews', onClick }) => {
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(average);
    const hasHalfStar = average % 1 >= 0.5;

    // Render full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={`full-${i}`} className="star star-full">
          ★
        </span>
      );
    }

    // Render half star if needed
    if (hasHalfStar) {
      stars.push(
        <span key="half" className="star star-half">
          ★
        </span>
      );
    }

    // Render empty stars to complete 5 stars
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="star star-empty">
          ☆
        </span>
      );
    }

    return stars;
  };

  return (
    <div className={`reviews-display ${onClick ? 'clickable' : ''}`} onClick={onClick}>
      <div className="reviews-info">
        <div className="stars-container">{renderStars()}</div>
        <span className="rating-text">{average.toFixed(1)}</span>
        <span className="reviews-count">
          ({count} {reviewsLabel})
        </span>
      </div>
    </div>
  );
};

export default ReviewsDisplay;
